import SwiperT from "@components/BasicComponents/Swiper/MySwiper"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAsset from "@components/WebsiteRevamp/ContentAsset/ContentAsset"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {SwiperSlide} from "swiper/react"
// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"

export type StoriesListSectionType = {
	data: AdvancedSideAssetModuleType
}

const StoriesListSection = (props: StoriesListSectionType) => {
	const mainContent = props.data.mainContent
	return (
		<section>
			<Separator backgroundColor={"#F8FAFE"}>
				<ContainerWrapper style={{overflow: "hidden"}}>
					{/* Title for Careers Stories Page */}
					<Typography
						content={props.data.sectionTitle}
						fontWeight={300}
						variant={Variant.SectionTitle}
					/>

					<SwiperT
						module={mainContent?.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<SwiperSlide key={index}>
										<Separator>
											<ContentAsset
												data={element}
												objectPosition={"top"}
												withAspectRation
											/>
										</Separator>
									</SwiperSlide>
								)
							},
						)}
					/>

					{/* <Separator size={32}>
						<ButtonComponent
							buttonType={"secondary"}
							link={props.data.sectionBottomButtonLink}
							size={"default"}
							asLink
						>
							{props.data.sectionBottomButton}
						</ButtonComponent>
					</Separator> */}
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default StoriesListSection
